import { objToList, objToLabelColorObj } from 'utils/util'

export const APPROVE_STATUS_OBJ = {
  1: {
    label: '审批中',
    color: 'blue',
  },
  2: {
    label: '审批通过',
    color: 'green',
  },
  3: {
    label: '审批否决',
    color: 'red',
  },
  4: {
    label: '已撤销',
    color: 'gray',
  },
}

export const APPROVE_STATUS_LIST = objToList(
  APPROVE_STATUS_OBJ,
  'text',
  'value',
)

export const APPROVE_STATUS_COLOR_OBJ = objToLabelColorObj(APPROVE_STATUS_OBJ)

export const MY_APPROVE_STATUS_OBJ = {
  1: {
    label: '通过',
    color: 'green',
  },
  2: {
    label: '不通过',
    color: 'red',
  },
}

export const MY_APPROVE_STATUS_LIST = objToList(
  MY_APPROVE_STATUS_OBJ,
  'text',
  'value',
)
